import React, { useMemo, useState } from 'react';
import ProductCard from '../components/ProductCard';
import productslogo from '../images/Gemini_Generated_Image_nvz1u8nvz1u8nvz1.png';
import tomatoTitle from '../images/tomoto-title.jpeg';
import cucumberTitle from '../images/cucumber-title.jpeg';
import chilliTitle from '../images/chilli-title.jpeg';
import brinjalTitle from '../images/brinjal-title.jpeg';
import watermelonTitle from '../images/watermelon-title.jpeg';
import muskmelonTitle from '../images/muskmelon-title.jpeg';
import bhendiTitle from '../images/bhendi-title.jpeg';
import pumpkinTitle from '../images/pumpkin-title.jpeg';
import bottlegourdTitle from '../images/bottlegourd-title.jpeg';
import carrotTitle from '../images/carrot-title.jpeg';
import bittergourdTitle from '../images/bittergourd-title.jpeg';
import spongegourdTitle from '../images/spongegourd-title.jpeg';
import ridgegourdTitle from '../images/ridgegourd-title.jpeg';
import radishTitle from '../images/radish-title.jpeg';
import cabbageTitle from '../images/cabbage-title.jpeg';
import onionTitle from '../images/onion-title.jpeg';
import sweetcornTitle from '../images/sweetcorn-title.jpeg';
import dolichosTitleImage from '../images/dolichos-title.png';
import clusterbeansTitle from '../images/clusterbeans-title.jpeg';
import frenchbeansTitle from '../images/frenchbeans-title.png';
import marigoldTitle from '../images/marigold-title.jpeg';
import yardlongbeansTitle from '../images/yardlongbeans-title.png';
import polebeansTitle from '../images/polebeans-title.png';
import capsicumTitle from '../images/capsicum-ambika-img.png';
import ashGourdImage from '../images/ashgourd-title.jpg';
import corianderImage from "../images/coriander-title.jpg"
import palak from "../images/palak-title.jpg"

const productTitleImages = {
  tomato: tomatoTitle,
  cucumber: cucumberTitle,
  chilli: chilliTitle,
  brinjal: brinjalTitle,
  watermelon: watermelonTitle,
  muskmelon: muskmelonTitle,
  bhendi: bhendiTitle,
  pumpkin: pumpkinTitle,
  bottlegourd: bottlegourdTitle,
  carrot: carrotTitle,
  bittergourd: bittergourdTitle,
  spongegourd: spongegourdTitle,
  ridgegourd: ridgegourdTitle,
  radish: radishTitle,
  cabbage: cabbageTitle,
  onion: onionTitle,
  sweetcorn: sweetcornTitle,
  dolichos: dolichosTitleImage,
  clusterbeans: clusterbeansTitle,
  frenchbeans: frenchbeansTitle,
  marigold: marigoldTitle,
  yardlongbean: yardlongbeansTitle,
  polebeans: polebeansTitle,
  capsicum: capsicumTitle,
  ashgourd: ashGourdImage,
  coriander: corianderImage,
  palak: palak,
};

const productsCatalog = [
  { name: 'Tomato', slug: 'tomato', type: 'vegetables' },
  { name: 'Chilli', slug: 'chilli', type: 'vegetables' },
  { name: 'Brinjal', slug: 'brinjal', type: 'vegetables' },
  { name: 'Watermelon', slug: 'watermelon', type: 'fruits' },
  { name: 'Muskmelon', slug: 'muskmelon', type: 'fruits' },
  { name: 'Bhendi', slug: 'bhendi', type: 'vegetables' },
  { name: 'Pumpkin', slug: 'pumpkin', type: 'vegetables' },
  { name: 'Cucumber', slug: 'cucumber', type: 'vegetables' },
  { name: 'Ridge gourd', slug: 'ridgegourd', type: 'vegetables' },
  { name: 'Bottle gourd', slug: 'bottlegourd', type: 'vegetables' },
  { name: 'Bitter gourd', slug: 'bittergourd', type: 'vegetables' },
  { name: 'Sponge gourd', slug: 'spongegourd', type: 'vegetables' },
  { name: 'Cabbage', slug: 'cabbage', type: 'vegetables' },
  { name: 'Onion', slug: 'onion', type: 'vegetables' },
  { name: 'Radish', slug: 'radish', type: 'vegetables' },
  { name: 'Sweet corn', slug: 'sweetcorn', type: 'vegetables' },
  { name: 'Carrot', slug: 'carrot', type: 'vegetables' },
  { name: 'Capsicum', slug: 'capsicum', type: 'vegetables' },
  { name: 'Dolichos', slug: 'dolichos', type: 'vegetables' },
  { name: 'Yardlong bean', slug: 'yardlongbean', type: 'vegetables' },
  { name: 'French beans', slug: 'frenchbeans', type: 'vegetables' },
  { name: 'Pole beans', slug: 'polebeans', type: 'vegetables' },
  { name: 'Cluster beans', slug: 'clusterbeans', type: 'vegetables' },
  { name: 'Marigold', slug: 'marigold', type: 'vegetables' },
  { name: 'Ash Gourd', slug: 'ashgourd', type: 'vegetables' },
  { name: 'Coriander', slug: 'coriander', type: 'vegetables' },
  { name: 'Palak', slug: 'palak', type: 'vegetables' },
];

const filterOptions = [
  { label: 'All Products', value: 'all' },
  { label: 'Vegetables', value: 'vegetables' },
  { label: 'Fruits', value: 'fruits' },
];

const Products = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const products = useMemo(() => {
    const filteredCatalog =
      activeFilter === 'all'
        ? productsCatalog
        : productsCatalog.filter((product) => product.type === activeFilter);

    const sortedCatalog = [...filteredCatalog].sort((a, b) => a.name.localeCompare(b.name));

    return sortedCatalog.map((product) => ({
      _id: product.slug,
      name: product.name,
      slug: product.slug,
      image: productTitleImages[product.slug],
    }));
  }, [activeFilter]);

  return (
    <div className="page products-page">
      <div className="products-hero-banner">
        <img src={productslogo} alt="Products banner" className="productslogo" />
      </div>

      <div className="container">
        <div className="section-header">
          <h2>Our Products</h2>
        </div>
        <div className="products-intro-text">
          <p style={{ marginBottom: '1rem' }}>At Dynasty Agriseeds., every seed carries the promise of progress. Guided by our legacy, we develop superior vegetable hybrids that enrich lives, achieve higher productivity, and support a sustainable farming future.</p>
          <p>Our high-performing portfolio sets new benchmarks in yield, disease resistance, and quality. From climate-resilient genetics to practical knowledge support, each Dynasty Agriseeds hybrid is carefully designed to deliver consistent performance and dependable returns for progressive farmers.</p>
        </div>

        <div className="category-filter">
          {filterOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`filter-btn${activeFilter === option.value ? ' active' : ''}`}
              onClick={() => setActiveFilter(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>

        <div className="products-grid products-grid--catalog">
          {products.map((product) => (
            <ProductCard
              key={product._id}
              product={product}
              showDescription={false}
              centerTitle
              imageFit="contain"
              to={`/products/${product.slug}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
